import {
  DatePicker,
  InputAdornment,
  Option,
  SearchAutocomplete,
  Select,
} from "@deere/fuel-react";
import {
  Box,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Grid,
  Input,
  InputLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import React, { useEffect, useState } from "react";
import "../../App.css";
import { getParentDealerAccountId, getUserDetailsFromUUC } from "../../api/api";
import {
  BRAZIL_CNTRY_CODE,
  DATA_ENTRY,
  DEERE_EMPLOYEE,
  DEERE_MANAGER,
  FOUR_POINT_FIVE,
  SALES_MANAGER_ROLE,
  SIX,
  SPANISH_COUNTRIES_CODE,
  THREE,
  TWO,
  TWO_POINT_FIVE,
  TXN_SCOPE,
} from "../../utilities/constants";
import { CASH_SALE, LEASE, RETAIL_NOTE } from "../../utilities/constants.js";
import {getUserName, getUserObj, hasRole} from "../../utilities/tp-validations.js";
import {
  cnvrtStringDateToNormalDateObj,
  formatDate,
} from "../../utilities/utils";
import ConnectedDomainDropdown from "../Transaction/connected-domain-dropdown";
import ConnectedTransactionBidDropdown from "../Transaction/connected-transaction-bid-dropdown";

function TransactionDetails(props) {
  const [error, setError] = useState("");
  const [salesPersonObj, setSalesPersonObj] = useState({
    label: "",
    isInValid: true,
  });

  useEffect(() => {
    if (props.actionType.action === TXN_SCOPE.CREATE) {
      const userObj = getUserObj(props);
      if(userObj.inValidUser){
          props.setSalesPersonId("");
          props.setSalesPersonName("");
          setSalesPersonObj((prevObj) => ({
              ...prevObj,
              isInValid: true,
              label: props.texts.ERR_INVLD_SP,
          }));
      }
      else if (
          props.dealerAccount === undefined ||
          props.dealerAccount === null ||
          props.dealerAccount.group3LeadId === undefined
      ) {
        props.setSalesPersonId("");
        props.setSalesPersonName("");
        setSalesPersonObj((prevObj) => ({
          ...prevObj,
          isInValid: true,
          label: props.texts.ERR_SAME_SP_DLSHP,
        }));
      } else {
        props.setSalesPersonId(userObj?.userId);
          let userName = getUserName(userObj);
          if (!userName || userName.trim() === "") {
              props.setSalesPersonName("");
              setSalesPersonObj((prevObj) => ({
                  ...prevObj,
                  isInValid: true,
                  label: props.texts.ERR_SP_NAME_INVLD,
              }));
          } else {
              props.setSalesPersonName(getUserName(userObj));
              setSalesPersonObj((prevObj) => ({
                  ...prevObj,
                  isInValid: false,
                  label: getUserName(userObj),
              }))
          }
        props.setParentDealerAccountDetailsAtTxn(
            props.dealerAccount?.group3LeadId
        );
      }
    } else {
      setSalesPersonObj((prevObj) => ({
        ...prevObj,
        label: props.transactions?.salesPersonName,
        isInValid: false,
      }));
    }
  }, []);

  useEffect(() => {
    if (props.dealerAccount && props.dealerAccount.group3LeadId)
      props.setParentDealerAccountDetailsAtTxn(
          props.dealerAccount?.group3LeadId
      );
  }, [props.dealerAccount]);

  const handleOnSalesPersonIdChange = async (e) => {
    const newSalesPersonId = e.target.value;
    const salesPersonObjUpdate = {
      isInValid: true,
      label: (
          <CircularProgress
              size="small"
              style={{ color: "#000", marginLeft: "7px" }}
          />
      ),
    };

    setSalesPersonObj(salesPersonObjUpdate);

    if (newSalesPersonId.length === 7) {
      if (newSalesPersonId.startsWith("X")) {
        try {
          const data = await getUserDetailsFromUUC(newSalesPersonId);
          if (data.inValidUser) {
            props.setSalesPersonId("");
            props.setSalesPersonName("");
            salesPersonObjUpdate.label = props.texts.ERR_INVLD_SP;
          } else if (data.dealerAccountId !== null) {
            const parentDealerAccountId = await getParentDealerAccountId(
                data.dealerAccountId
            );

            if (
                props.parentDealerAccountId.group3LeadId ===
                parentDealerAccountId.toString()
            ) {
              props.setSalesPersonId(newSalesPersonId);
              props.setParentDealerAccountDetailsAtTxn(parentDealerAccountId);
                let userName = getUserName(data);
                if (!userName || userName.trim() === "") {
                    props.setSalesPersonName("");
                    salesPersonObjUpdate.label = props.texts.ERR_SP_NAME_INVLD;
                } else {
                    props.setSalesPersonName(getUserName(data));
                    salesPersonObjUpdate.isInValid = false;
                    salesPersonObjUpdate.label = getUserName(data);
                }
            } else {
              props.setSalesPersonId("");
              props.setSalesPersonName("");
              salesPersonObjUpdate.label = props.texts.ERR_SAME_SP_DLSHP;
            }
          } else {
            props.setSalesPersonId("");
            props.setSalesPersonName("");
            salesPersonObjUpdate.label = props.texts.ERR_SP_INCR;
          }
        } catch (error) {
          props.setSalesPersonId("");
          props.setSalesPersonName("");
          salesPersonObjUpdate.label = props.texts.UNKNOWN_SERVER_ERROR;
        }
      } else {
        props.setSalesPersonId("");
        props.setSalesPersonName("");
        salesPersonObjUpdate.label = props.texts.ERR_SP_STARTX;
      }
    } else {
      props.setSalesPersonId("");
      props.setSalesPersonName("");
      salesPersonObjUpdate.label = props.texts.ERR_SP_LEN;
    }

    setSalesPersonObj((prevObj) => ({ ...prevObj, ...salesPersonObjUpdate }));
  };

  const handleDealResultValue = (e) => {
    const id = "dealResult";
    props.setTransactionBidDropdownValue(id, e.target.value);
    if (e.target.value === "Won") {
      props.transactions.bids.forEach((bid) => {
        if (bid.bidType !== "JD") {
          props.setBidsTextValue(id, "Lost", bid.bidType);
        } else {
          props.setBidsTextValue(id, e.target.value, "JD");
        }
      });
    } else {
      props.setBidsTextValue(id, e.target.value, "JD");
    }
  };

  const handleDealerAccountChange = (e, v, reason) => {
    try {
      if (reason && reason === "clear") {
        props.setTransactionRequestDropdownValue("dealerAccountId", "");
        props.setTransactionRequestDropdownValue("dealerAddress", "");
      } else {
        props.setTransactionRequestDropdownValue("dealerAccountId", v.id);
        props.setTransactionRequestDropdownValue(
            "dealerAddress",
            "".concat(
                v.value.physicalAddress.element
                    .filter((item) => item.name === "City" || item.name === "State")
                    .map((address) => {
                      return address.value;
                    })
            )
        );
        props.setBidsTextValue("dealerName", v.value.accountName, "JD");
      }
    } catch (e) {}
  };

  const getOptionsForMarketSegment = () => {
    if (hasRole(DEERE_MANAGER, props) || hasRole(DEERE_EMPLOYEE, props)) {
      return [
        ...props.domainDetails["MARKET_SEGMENT"],
        ...props.domainDetails["MARKET_SEGMENT_LAT"],
        ...props.domainDetails["MARKET_SEGMENT_BR"],
      ];
    }
    return getUserObj(props).countryCode === BRAZIL_CNTRY_CODE
        ? props.domainDetails["MARKET_SEGMENT_BR"]
        : SPANISH_COUNTRIES_CODE.includes(getUserObj(props).countryCode)
            ? props.domainDetails["MARKET_SEGMENT_LAT"]
            : props.domainDetails["MARKET_SEGMENT"];
  };

  return (
      <Box p={5} bgcolor={"white"} sx={{ borderRadius: "4px", paddingBottom: 4 }}>
        <Typography variant="h3" component="h3">
          {props.texts.CUSTOMER_AND_DEAL_INFO}
        </Typography>
        <Grid item xs>
          <Grid alignItems="flex-start" container spacing={SIX} p={1}>
            <Grid item xs={THREE}>
              <FormControl fullWidth required>
                <InputLabel htmlFor="customerName">
                  {props.texts.CUSTOMER_NAME}
                </InputLabel>
                <Input
                    type={"text"}
                    fullWidth
                    id="customerName"
                    placeholder="Name"
                    value={props.transactions.customerName}
                    readOnly={props.actionType.action === "view"}
                    onChange={(e) => {
                      props.setTextValue("customerName", e.target.value);
                      if (e.target.value.trim() !== "") {
                        setError("");
                      } else {
                        setError(props.texts.CUST_NAME_VALIDATION);
                      }
                    }}
                    error={
                      props.errorFields.length !== 0 &&
                      props.transactions.customerName === ""
                    }
                />
                <FormHelperText style={{ color: "red" }}>{error}</FormHelperText>
              </FormControl>
            </Grid>
            <ConnectedDomainDropdown
                options={getOptionsForMarketSegment()}
                xs={THREE}
                id="dealMarket"
                label={props.texts.MARKET_SEGMENT}
            />
          </Grid>
        </Grid>
        <Grid item xs>
          <Grid alignItems="flex-start" container spacing={FOUR_POINT_FIVE} p={1}>
            <Grid item xs={TWO_POINT_FIVE} sx={{ minWidth: 0 }}>
              <InputLabel htmlFor="dealerAccount" required>
                {props.texts.TP_DEALER_ACCOUNT}
              </InputLabel>
              {props.actionType.action !== "Create" ? (
                  <SearchAutocomplete
                      className="transaction-dealer-account"
                      componentsProps={{
                        popper: { className: "transaction-dealer-account-popper" },
                      }}
                      readOnly={props.actionType.action === "view"}
                      value={
                        props.transactionRequest.dealerAddress +
                        "(" +
                        props.transactionRequest.dealerAccountId +
                        ")"
                      }
                      fullWidth
                      style={{
                        borderRadius: "5px",
                        border:
                            props.errorFields.length !== 0 &&
                            props.transactionRequest.dealerAccountId === ""
                                ? "1px solid #c21020"
                                : "none",
                      }}
                      onChange={handleDealerAccountChange}
                      options={
                        (props.relatedDealerAccount &&
                            props.relatedDealerAccount.length > 0 &&
                            props.relatedDealerAccount.map((account) => ({
                              label: "".concat(
                                  account.physicalAddress.element
                                      .filter(
                                          (item) =>
                                              item.name === "City" || item.name === "State"
                                      )
                                      .map((value) => {
                                        return value.value;
                                      }),
                                  "(",
                                  account.accountId,
                                  ")"
                              ),
                              value: account,
                              id: account.accountId,
                            }))) ||
                        []
                      }
                      TextFieldProps={{
                        placeholder: props.texts.ENT_DEALR_ACC,
                        helperText:
                            props.transactionRequest?.dealerAddress &&
                            props.transactionRequest?.dealerAccountId
                                ? props.transactionRequest.dealerAddress +
                                " (" +
                                props.transactionRequest.dealerAccountId +
                                ")"
                                : "",
                      }}
                  />
              ) : (
                  <SearchAutocomplete
                      className="transaction-dealer-account"
                      componentsProps={{
                        popper: { className: "transaction-dealer-account-popper" },
                      }}
                      readOnly={props.actionType.action === "view"}
                      fullWidth
                      style={{
                        borderRadius: "5px",
                        border:
                            props.errorFields.length !== 0 &&
                            props.transactionRequest.dealerAccountId === ""
                                ? "1px solid #c21020"
                                : "none",
                      }}
                      onChange={handleDealerAccountChange}
                      options={
                        (props.relatedDealerAccount &&
                            props.relatedDealerAccount.length > 0 &&
                            props.relatedDealerAccount.map((account) => ({
                              label: "".concat(
                                  account.physicalAddress.element
                                      .filter(
                                          (item) =>
                                              item.name === "City" || item.name === "State"
                                      )
                                      .map((value) => {
                                        return value.value;
                                      }),
                                  "(",
                                  account.accountId,
                                  ")"
                              ),
                              value: account,
                              id: account.accountId,
                            }))) ||
                        []
                      }
                      TextFieldProps={{
                        placeholder: props.texts.ENT_DEALR_ACC,
                        helperText:
                            props.transactionRequest?.dealerAddress &&
                            props.transactionRequest?.dealerAccountId
                                ? props.transactionRequest.dealerAddress +
                                " (" +
                                props.transactionRequest.dealerAccountId +
                                ")"
                                : "",
                      }}
                  />
              )}
            </Grid>
            <Grid item xs={1.25}>
              <TextField
                  fullWidth
                  label={props.texts.SALESPERSON_ID}
                  id="salespersonID"
                  placeholder={props.texts.SALESPERSON_ID}
                  readOnly={props.actionType.action === "view"}
                  required={true}
                  inputProps={{ maxLength: 7 }}
                  disabled={
                    !hasRole(SALES_MANAGER_ROLE, props) &&
                    !(props.simulatedUserDetails?.authorizedRoles &&
                    props.isSimulateMode
                        ? props.simulatedUserDetails?.authorizedRoles["A1341.1.3"] ===
                        DATA_ENTRY
                        : props.userDetails?.authorizedRoles["A1341.1.3"] ===
                        DATA_ENTRY)
                  }
                  defaultValue={
                    props.actionType.action === "Create"
                        ? getUserObj(props).userId
                        : props.transactions.salePersonID
                  }
                  onChange={handleOnSalesPersonIdChange}
                  onInput={(e) =>
                      (e.target.value = e.target.value
                          .replace(/[^a-zA-Z0-9]/g, "")
                          .toUpperCase())
                  }
                  error={salesPersonObj.isInValid}
                  helperText={salesPersonObj.label}
              />
            </Grid>
            <ConnectedDomainDropdown
                options={props.domainDetails["DEAL_TYPE"]}
                xs={1.25}
                id="dealType"
                label={props.texts.DEAL_TYPE}
            />
            <Grid item xs={1}>
              <TextField
                  fullWidth
                  id="quantity"
                  label="Quantity"
                  type="number"
                  onChange={(e) => {
                    props.setTextValue("quantity", parseInt(e.target.value));
                  }}
                  onInput={(e) =>
                      (e.target.value = e.target.value
                          .replace(/[^0-9]/g, "")
                          .toUpperCase())
                  }
                  value={props.transactions?.quantity ?? 1}
                  error={
                    props.errorFields.length !== 0 &&
                    (!props.transactions?.quantity ||
                        props.transactions?.quantity === 0)
                  }
                  disabled={
                    props.actionType.action === "view" ||
                    props.transactions?.dealType === "Single Unit" ||
                    props.transactions?.dealType === ""
                  }
                  required
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs>
          <Grid item xs p={1}>
            <Typography variant="h4" component="h4">
              {props.texts.TRAN_DETAILS}
            </Typography>
          </Grid>
          <Grid alignItems="flex-start" container spacing={FOUR_POINT_FIVE} p={1}>
            <Grid item xs={3}>
              <FormControl component="fieldset">
                <FormLabel required>{props.texts.RESULT}</FormLabel>
                <RadioGroup
                    row
                    id="dealResult"
                    onChange={handleDealResultValue}
                    value={props.transactions.bids[0].dealResult}
                    disabled={props.actionType.action === "view" ? true : false}
                >
                  <FormControlLabel
                      control={
                        <Radio disabled={props.actionType.action === "view"} />
                      }
                      label={props.texts.WON}
                      value="Won"
                  />
                  <FormControlLabel
                      control={
                        <Radio disabled={props.actionType.action === "view"} />
                      }
                      label={props.texts.LOST}
                      value="Lost"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <ConnectedTransactionBidDropdown
                options={props.domainDetails["REASON_OF_RESULT"]}
                xs={3}
                id="saleReason"
                p={1}
                label={props.texts.RESULT_REASON}
            />
          </Grid>
        </Grid>
        <Grid item xs>
          <Grid alignItems="flex-start" container spacing={7} p={1}>
            <ConnectedDomainDropdown
                options={props.domainDetails["CURRENCY_TYPE"]}
                xs={TWO_POINT_FIVE}
                id="currency"
                label={props.texts.CURRENCY}
            />
            <Grid item xs={FOUR_POINT_FIVE}>
              <FormControl component="fieldset">
                <FormLabel>{props.texts.PAYMENT_METHOD}</FormLabel>
                <RadioGroup
                    row
                    id="paymentType"
                    //  disabled={props.actionType.action === "view" ? true : false}
                    defaultValue={
                      props.actionType.action === "Create"
                          ? CASH_SALE.title
                          : props.paymentMethod
                    }
                    onChange={(e) => {
                      props.setTransactionPaymentDropdownValue(
                          "paymentType",
                          e.target.value
                      );
                      props.setPaymentMethod(e.target.value);
                      props.resetPaymentTypeObject(props);
                      props.calculateSpreadAndMargin(props);
                    }}
                >
                  <FormControlLabel
                      control={
                        <Radio
                            disabled={
                              props.actionType.action === "view" ? true : false
                            }
                        />
                      }
                      label={props.texts.CASH_SALE}
                      value={CASH_SALE.title}
                  />
                  <FormControlLabel
                      control={
                        <Radio
                            disabled={
                              props.actionType.action === "view" ? true : false
                            }
                        />
                      }
                      label={props.texts.LEASE}
                      value={LEASE.title}
                  />
                  <FormControlLabel
                      control={
                        <Radio
                            disabled={
                              props.actionType.action === "view" ? true : false
                            }
                        />
                      }
                      label={props.texts.RETAIL_MUNY_LEASE}
                      value={RETAIL_NOTE.title}
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs p={1}>
          <Grid alignItems="flex-start" container spacing={SIX}>
            <Grid item xs={TWO}>
              <FormControl fullWidth required>
                <InputLabel htmlFor="transactionDate" placeholder="date">
                  {props.texts.TRAN_QUOTE_DATE}
                </InputLabel>
                <DatePicker
                    readOnly={props.actionType.action === "view"}
                    defaultValue={
                      props.actionType.action === "Create"
                          ? new Date()
                          : cnvrtStringDateToNormalDateObj(props.transactions.txnDate)
                    }
                    onChange={(date) => {
                      props.setTextValue("txnDate", formatDate(date));
                    }}
                    InputProps={{
                      startAdornment: (
                          <InputAdornment position="start">
                            <CalendarMonthIcon />
                          </InputAdornment>
                      ),
                    }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={TWO_POINT_FIVE} style={{ scrollMarginBlock: "auto" }}>
              <FormControl fullWidth>
                <InputLabel
                    htmlFor="Films"
                    id="Films-label"
                >
                  {props.texts.DISCOUNT_PROGRAM_FIELD}
                </InputLabel>
              <Select
                  hasSearch
                  hasSelectAll
                  multiple
                  fullWidth={true}
                  id="discountProgram"
                  disabled={props.actionType.action === "view"}
                  placeholder={`${props.texts.SELECT} ${props.texts.DISCOUNT_PROGRAM_FIELD}`}
                  value={props.discountPrograms}
                  renderValue={(program) => program.map((x) => x).join(", ")}
                  onChange={(event) => {
                    const selected = Array.from(event.target.selectedOptions, (option) => {
                      const description = props.domainDetails.DISCOUNT_PROGRAMS?.find(
                          (desc) => desc.domainValue.toString() === option.value
                      );
                      return description;
                    });
                    props.setDiscountProgram(selected.map((option) => option.domainValue.toString()));
                    //onSelectionChange(selected);
                  }
                  }
              >
                  {props.domainDetails.DISCOUNT_PROGRAMS.map((program, index) => {
                    return (
                        <Option key={program.domainValue}
                                value={program.domainValue}>
                          {program.domainValue}
                        </Option>
                    );
                  })}
              </Select>
              </FormControl>
            </Grid>
            <ConnectedDomainDropdown
                options={props.domainDetails["COMPETITIVE_BIDS"]}
                xs={1.5}
                fullWidth={false}
                id="compBids"
                label={props.texts.COMPETITIVE_BIDS}
            />
          </Grid>
        </Grid>
        <Grid item xs p={1}>
          <TextField
              id="comments"
              label={props.texts.COMMNTS_TRDE_INFO}
              disabled={props.actionType.action === "view"}
              value={props.transactions.remarks}
              type="text"
              sx={{ width: 705 }}
              multiline
              minRows={4}
              inputProps={{ maxLength: 1000 }}
              onChange={(e) => props.setTextValue("remarks", e.target.value)}
          />
        </Grid>
      </Box>
  );
}

export default TransactionDetails;